<template>
  <div class="container-content" :class="isBigSize ? 'bigCard' : 'smallCard'">
    <div class="container-content-title">
      <img :src="titleIcon" :alt="title" />
      <div class="content-title-main">{{ title }}</div>
      <slot name="search-slot" />
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "cardBox",
  components: {},
  props: {
    title: {
      type: String,
      default: "标题",
    },
    titleIcon: {
      type: String,
      default: "",
    },
    isBigSize: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {},
  beforeDestroy() {},
};
</script>
<style scoped>
.container-content {
  margin-top: 30px;
  margin-left: 20px;
  background-color: #ffffff;
  font-family: FZLTHJW--GB1-0;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
  overflow: hidden;
}

/* 容器宽度 */
.bigCard {
  width: 1658px;
  height: 95%;
  min-height: 827px;
}

.smallCard {
  width: 665px;
}

.container-content-title {
  display: -webkit-flex; /* Safari */
  display: flex;
  align-items: center;
  margin-top: 45px;
  margin-left: 40px;
  margin-right: 40px;
}

.container-content-title .content-title-main {
  display: inline;
  font-size: 26px;
  line-height: 26px;
  padding-left: 14px;
}

.container-content-title img {
  max-height: 32px;
}
</style>